export default "__VITE_ASSET__DR$Rat1r__"